export const customPalette = {
  primaryDark: '#002A3A',
  defaultFontColor: '#333333',
  red: '#E4002B',
  darkBlue: '#000033',
  greyColor: '#ECECEB',
  footerBackground: '#222731',
  badge: '#E6EDF1',
  themeColor: '#004F71',
  lightBlue: '#007ACC',
  buttonFontColor: '#FFFFFF',
  bodyColor: '#63666A',
  gridBoxColor: '#E6EAF3',
  gridLineColor: '#B1C5E3',
  dividerBorder: '#D9D9D6',
  cardBorder: '#E6EDF1',
  badgeBorder: '#80A7B8',
  utility: {
    danger: '#FFEBEB',
    warning: '#FFF7E6',
    success: '#EDFBE6',
    info: '#E6F7FD'
  }
};
